import { ReactNode, useMemo, useState } from 'react';
import { SelectFigurantContext } from './context';
import { Select } from './types';

export const initState = {
  searchFigurant: '',
  selectedFigurant: [],
  searchFiscal: '',
  selectedFiscal: [],
  step: 1,
};

export const SelectFigurantProvider = ({ children }: { children: ReactNode }) => {
  const [select, setSelect] = useState<Select>(initState);

  const contextValue = useMemo(() => ({ select, setSelect }), [select]);

  return <SelectFigurantContext.Provider value={contextValue}>{children}</SelectFigurantContext.Provider>;
};

export default SelectFigurantProvider;
